import { render, staticRenderFns } from "./MessageDeleteConfirm.vue?vue&type=template&id=64c261b6&"
import script from "./MessageDeleteConfirm.vue?vue&type=script&lang=ts&"
export * from "./MessageDeleteConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports